import { useRef, useState } from 'react';
import { Box, Typography, Chip, Button, useMediaQuery } from '@mui/material';
import { Info } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAccount } from '../contexts/Account';
import {
  searchAdvisorByFilters,
  searchAdvisorByFiltersLegacy,
} from '../services/advisor_services';
import CompanySearchAdvisorsContent from './SearchAdvisors/SearchAdvisorsContent';
import SceneContentStateSelector from '../components/SceneContentStateSelector';
import {
  EndpointResponseObjectName,
  EndpointParameterFilters,
} from '../services/utils/types';
import { isNil } from '../services/utils';
import ACToolTip from '../components/ACToolTip';
import Treatment from '../components/Treatment';
import { featureFlags } from '../splitSetup';
import CompanyTopTilesContainer from '../components/Advisor/TopBar/TopTiles';
import SearchFilter from '../components/Company/SearchFilter';

const getClasses = (isSM) => ({
  container: {
    // display: 'flex',
    // flex: 'auto',
    // flexDirection: 'column',
    // paddingLeft: isSM ? '10px' : '30px',
    // paddingBottom: '20px',
    // paddingRight: isSM ? '10px' : '30px',
    // overflowY: isSM ? 'auto' : 'unset',
    // height: isSM ? '100%' : 'auto',
    padding: isSM ? '10px' : '30px',
  },
  containerInfo: {
    paddingTop: '20px',
    marginLeft: '5px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  iconInfo: {
    fontSize: '20px',
    cursor: 'pointer',
    marginLeft: '5px',
  },
  chip: {
    // p: '10px',
    backgroundColor: '#F5F7FA',
    color: '#000',
  },
});

function Networking(props) {
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = getClasses(isSM);
  const [doNotFetch, setDoNotFetch] = useState(false);
  const [searchApplied, setSearchApplied] = useState(false);
  const { accountDetails, currentUserInfo } = useAccount();
  const [queryParameters, setQueryParameters] = useState({
    SEARCH_STRING: '',
    LIMIT: EndpointParameterFilters.FETCH_LIMIT,
    OFFSET: 0,
    SKILLS_TAGS_IDS: [],
    INDUSTRY_TAGS_IDS: [],
    IS_NEW: true,
    CREATED_SORT: true,
    COMPANY_ID: accountDetails.id,
    SEARCH_FILTER: false,
    FILTER_TYPE: '',
  });
  const { t } = useTranslation();

  function handleSearch(props) {
    const { keywords, skills, position, industries, invitedFilter } = props;
    const searchString = {
      SEARCH_STRING: null,
      SKILLS_TAGS_IDS: null,
      INDUSTRY_TAGS_IDS: null,
      LIMIT: EndpointParameterFilters.FETCH_LIMIT,
      OFFSET: 0,
      IS_NEW: false,
      CREATED_SORT: true,
      COMPANY_ID: accountDetails.id,
      SEARCH_FILTER: !!invitedFilter,
      FILTER_TYPE: invitedFilter,
    };
    let searchApplied = false;
    if (keywords && keywords.length > 0) {
      searchString.SEARCH_STRING = keywords;
      searchApplied = true;
    } else {
      delete searchString.SEARCH_STRING;
    }
    if (!isNil(skills) && skills[0]) {
      searchString.SKILLS_TAGS_IDS = skills.map((skill) => skill.id);
      searchApplied = true;
    } else {
      delete searchString.SKILLS_TAGS_IDS;
    }
    if (!isNil(position) && position[0]) {
      searchString.POSITION_TAGS_IDS = position.map(
        (singlePosition) => singlePosition.id
      );
      searchApplied = true;
    } else {
      delete searchString.POSITION_TAGS_IDS;
    }
    if (!isNil(industries) && industries[0]) {
      searchString.INDUSTRY_TAGS_IDS = industries.map(
        (industry) => industry.id
      );
      searchApplied = true;
    } else {
      delete searchString.INDUSTRY_TAGS_IDS;
    }
    if (searchApplied) {
      searchString.CREATED_SORT = false;
    }
    setDoNotFetch(false);
    setQueryParameters(searchString);
    setSearchApplied(
      searchString.SEARCH_STRING ||
        searchString.INDUSTRY_TAGS_IDS ||
        searchString.SKILLS_TAGS_IDS ||
        searchString.POSITION_TAGS_IDS
    );
  }

  const contentRef = useRef(null);

  return (
    <Box sx={{ backgroundColor: '#F4F8FF', width: '100%' }}>
      <Box
        sx={{
          mx: isSM ? '20px' : '40px',
          mb: '0px',
          mt: '40px',
          bgcolor: 'white',
          zIndex: 0,
          borderRadius: '15px',
        }}
      >
        <CompanyTopTilesContainer
          circleFirstColor="rgba(215, 241, 253, 1)"
          circleSecondColor="rgba(219, 247, 235, 1)"
          title="Engage in Valuable Senior-Level Networking"
          subtitle="Network with thousands of leading professionals in a worth-your-time way, and see how the right connections can open doors to new opportunities."
          circleAlternative
          compactView
          zIndex={1}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: isSM ? '10px' : '20px',
              mt: '20px',
            }}
          >
            <Chip label="Share Best Practices" sx={classes.chip} />
            <Chip label="Swap Introductions" sx={classes.chip} />
            <Chip label="Business Proposition" sx={classes.chip} />
            <Chip label="Startup Opportunities" sx={classes.chip} />
            <Chip label="Feedback & Ideas" sx={classes.chip} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '10px',
              my: '20px',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              id="networkingGetFeatured"
              className="headerButton"
              sx={{
                width: '218px',
                borderRadius: '40px',
                backgroundColor: '#3171F6',
                textTransform: 'none',
                height: '45px',
                margin: '5px',
                fontStyle: 'normal',
                fontWeight: 700,
                fontSize: '15px',
                lineHeight: '24px',
                letterSpacing: '-0.43px',
                color: '#FFFFFF',
                padding: '5px',
                '&:hover': {
                  backgroundColor: '#3171F6',
                },
              }}
            >
              Get Featured
            </Button>
          </Box>
        </CompanyTopTilesContainer>
      </Box>

      <div ref={contentRef} style={classes.container}>
        <SearchFilter onSearchButtonClicked={handleSearch} hidePeerFilter />

        {searchApplied ? (
          <>
            <div style={classes.containerInfo}>
              <Typography variant="old_font">
                Why are you seeing these results?
              </Typography>
              <ACToolTip
                title='Search includes results from advisors’ skill tags, biography, and professional experience. You can search for exact matches by placing phrases in quotes like "Digital Marketing". Click an advisor to view their profile and learn more.'
                placement="top"
              >
                <Info sx={classes.iconInfo} />
              </ACToolTip>
            </div>
          </>
        ) : null}
        <Treatment
          userId={currentUserInfo.username}
          splitNames={featureFlags.opensearch_migration}
          updateOnSdkTimedout
          evaluatedComponent={
            <SceneContentStateSelector
              helmetTitle="Networking"
              endPointAppSyncName={
                EndpointResponseObjectName.SEARCH_ADVISOR_BY_FILTERS
              }
              endPointCall={searchAdvisorByFilters}
              endPointCallParameters={queryParameters}
              ContentTag={CompanySearchAdvisorsContent}
              contentProps={{
                searchApplied,
              }}
              doNotShowEmptyStateScene
              doNotFetch={doNotFetch}
              isCardSkeleton
              noMaxWidth
            />
          }
          conditionFlag
          conditionFailedComponent={
            <SceneContentStateSelector
              helmetTitle="My Advisors"
              endPointAppSyncName={
                EndpointResponseObjectName.SEARCH_ADVISOR_BY_FILTERS_LEGACY
              }
              endPointCall={searchAdvisorByFiltersLegacy}
              endPointCallParameters={queryParameters}
              ContentTag={CompanySearchAdvisorsContent}
              contentProps={{
                searchApplied,
              }}
              doNotShowEmptyStateScene
              doNotFetch={doNotFetch}
              isCardSkeleton
              noMaxWidth
            />
          }
        />
      </div>
    </Box>
  );
}
export default Networking;
